import PropTypes from "prop-types";
import React from "react";

import { Button2 } from "@/ui2/atoms/Button";
import { cn } from "@/lib/helpers/cn";
import { Text } from "@/component-library/Text";
import { TwoButtonCard } from "@/component-library/TwoButtonCard";

import "./styles.scss";

export const PSSProviderNoShow = ({ className, onClickCancel, onClickConfirm, ...props }) => (
  <TwoButtonCard
    buttonLeft={
      <Button2 onPress={onClickCancel} variant="secondary">
        No, I’m All Set
      </Button2>
    }
    buttonRight={<Button2 onPress={onClickConfirm}>Yes, Message My Provider</Button2>}
    className={cn("apti-PSSProviderNoShow", className)}
    {...props}
  >
    <div className="text-center apti-TwoButtonCard-title">
      <Text className="apti-TwoButtonCard-title-font" color="grey">
        It looks like your provider didn’t join your session. Do you need to contact them?
      </Text>
    </div>
  </TwoButtonCard>
);

PSSProviderNoShow.propTypes = {
  className: PropTypes.string,
  onClickCancel: PropTypes.func.isRequired,
  onClickConfirm: PropTypes.func.isRequired,
};

PSSProviderNoShow.defaultProps = {
  className: undefined,
  onClickCancel: () => {},
  onClickConfirm: () => {},
};
